import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

function PersuasionModalLogin({ toggle, isOpen, openConfigModals }) {
  const handleConfigurar = () => {
    openConfigModals();
    toggle();
  };

  return (
    <div>
      <Modal isOpen={isOpen} centered>
        <ModalHeader className="border-0 pb-0" toggle={toggle} />
        <ModalBody className=" pb-0">
          <>
            <FontAwesomeIcon icon={faLock} className="mr-4 w-100" color="var(--primary)" size="4x" />
            <div className="p-2 w-100 d-flex flex-column justify-content-center ">
              <h5 className="badge-pills mt-4 mb-4 p-2" style={{ fontSize: "18px" }}>
                ¡Tomate un minuto para proteger tu cuenta y tu información!
              </h5>
              <p className="badge-pills h-50 w-100 justify-content-center text-justify p-2" style={{ fontSize: "14px", fontWeight: "normal", padding: "10px 0" }}>
                La autenticación en dos factores (2FA) puede ayudarte a proteger tu cuenta incluso si alguien conoce tu contraseña.
              </p>
            </div>
          </>
        </ModalBody>
        <ModalFooter className="border-0">
          <Button color="btn btn-primary" onClick={handleConfigurar}>
            Habilitar 2FA ahora
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default PersuasionModalLogin;
